"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGEventTranslation = void 0;
exports.SVGEventTranslation = {
    getSVG: function (element) {
        while (element.parentNode != null) {
            if (element.nodeName === 'svg') {
                return element;
            }
            element = element.parentNode;
        }
        return null;
    },
    translatePoint: function (point, ctm) {
        return point.matrixTransform(ctm.inverse());
    },
    translateXY: function (x, y, element) {
        var svg = exports.SVGEventTranslation.getSVG(element);
        if (svg == null) {
            return null;
        }
        var matrix = svg.getScreenCTM();
        var point = svg.createSVGPoint();
        point.x = x;
        point.y = y;
        return exports.SVGEventTranslation.translatePoint(point, matrix);
    },
    translateEvent: function (evt) {
        return exports.SVGEventTranslation.translateXY(evt.clientX, evt.clientY, evt.target);
    }
};
//# sourceMappingURL=svg.event.translation.js.map